<template>
  <div class="warpDailshuo" style="background-color:#FFFFFF;">
      <div class="dail">
           <img class="bns" src="@/assets/shuomin.png" alt="">
           <div>
              <div class="title">IOT 智慧消防</div> 
              <div class="small" style="padding-left: 10px;">IOT Intelligent fire protection </div>
              <div style="position:relative;height:340px;">
                <div>
                  <ul style="position:absolute;left:-50px;top:0">
                    <li>实时监测</li>
                    <li>远程控制</li>
                    <li>精准定位</li>
                    <li>快速响应</li>
                  </ul>
                </div>
                <div>
                  <ul style="position:absolute;left:175px;top:0">
                    <li>信息共享与管理</li>
                    <li>智能分析</li>
                    <li>事务处理</li>
                    <li>风险评估</li>
                  </ul>
                </div>
              </div>
              <div class="Btn" @click="BtnURL">已入加盟？立即登录</div> 
           </div>
      </div>
  </div>
</template>

<script>
export default {
    data() {
      return {
        
      }
    },
    methods: {
      BtnURL(){
          window.open("https://www.wanwu360.com/#/Login")
      }
    }
}
</script>

<style lang="scss" scoped>
      .warpDailshuo{
           padding: 120px 0; 
          .dail{
              width:1200px;
              margin:0 auto;
              display:flex;
              justify-content:space-between;
              .title{
                  height: 45px;
                  font-size: 32px;
                  font-family: Alibaba_Bold;
                  color: #333333;
              }
              .small{
                  font-size: 14px;
                  font-family: Helvetica;
                  color: #67686A;
                  padding-top:16px;
                  padding-bottom:56px;
              }
              li{
                font-size: 20px;
                font-family: Alibaba_Medium;
                color: #333333;
                padding-bottom:20px;
                width:300px;
              }
              .bns{
                width:552px;
                height:524px;
                border-radius: 10px;
              }
          }
          .Btn{
            font-size: 20px;
            background-color:#367CFF;
            font-family: Alibaba_Bold;
            color: #FFFFFF;
            width: 254px;
            height: 58px;
            border-radius: 29px;
            text-align:center;
            line-height:58px;
          }
    }
</style>